import { useMemo, useContext } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";

import { AuthContext } from "@contexts/AuthContext";
import { getMUIThemeByRole, getCSSThemeByRole } from "@libs/themeHelper";
import AnimatedRoutes from "@pages/AnimatedRoutes";
import WidthWarningPop from "@components/WidthWarningPop";

function App() {
  const { currentUserRole } = useContext(AuthContext);

  const MUItheme = useMemo(
    () => getMUIThemeByRole(currentUserRole),
    [currentUserRole]
  );

  const CSStheme = useMemo(
    () => getCSSThemeByRole(currentUserRole),
    [currentUserRole]
  );

  return (
    <div data-theme={CSStheme}>
      <ThemeProvider theme={MUItheme}>
        <CssBaseline />
        <Router>
          <WidthWarningPop />
          <AnimatedRoutes currentUserRole={currentUserRole} />
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
